import React, { useEffect, useState } from 'react';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import { subscription as subscriptionApi } from '@afosto/iam/api/Subscription';
import Typography from '@material-ui/core/Typography';
import formatCurrency from '@afosto/utils/formatCurrency';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import CardHeader from '@material-ui/core/CardHeader';
import translations from './translations';
import useIntl from '@afosto/utils-react/intl/useIntl';

const UpcomingInvoiceSection = () => {
  const intl = useIntl();
  const [data, setData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchUpcomingInvoice = async () => {
      try {
        const response = await subscriptionApi.getUpcoming({ code: 'qcq' });

        if (isMounted) {
          setData(response.data);
        }
      } catch (error) {
        if (isMounted) {
          setData(null);
        }
      }
    };

    fetchUpcomingInvoice();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Card>
      <CardHeader
        title={<FormattedMessage {...translations.title} />}
        titleTypographyProps={{ variant: 'h6' }}
        action={
          <Typography variant="subtitle1">
            {data && (
              <>
                <FormattedDate
                  value={data?.start_at ? new Date(data.start_at) : null}
                  year="numeric"
                  month="short"
                  day="numeric"
                />{' '}
                -{' '}
                <FormattedDate
                  value={data?.end_at ? new Date(data.end_at) : null}
                  year="numeric"
                  month="short"
                  day="numeric"
                />
              </>
            )}
          </Typography>
        }
      />
      <CardContent>
        <Grid container alignItems="flex-end" spacing={1}>
          {(data?.products ?? []).map(product => (
            <>
              <Grid item xs={6}>
                <ListItemText primary={product?.name} secondary={product?.description} />
              </Grid>
              <Grid item xs={3}>
                <ListItemText
                  primary={intl.formatNumber(product?.quantity)}
                  primaryTypographyProps={{ align: 'right' }}
                />
              </Grid>
              <Grid item xs={3}>
                <ListItemText
                  primary={product?.amount ? formatCurrency(product.amount / 100) : '-'}
                  primaryTypographyProps={{ align: 'right' }}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </>
          ))}
          <Grid item xs={12}>
            {data?.is_trial && (
              <>
                <Box display="flex" justifyContent="space-between" pt={2}>
                  <Typography variant="subtitle1">
                    <FormattedMessage {...translations.subtotal} />
                  </Typography>
                  <Typography variant="subtitle1">
                    {data?.total ? formatCurrency(data.total / 100) : '-'}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" pt={1}>
                  <Typography variant="subtitle1">
                    <FormattedMessage {...translations.trialPeriod} />
                  </Typography>
                  <Typography variant="subtitle1">
                    {data?.total ? formatCurrency(-data.total / 100) : '-'}
                  </Typography>
                </Box>
              </>
            )}
            <Box display="flex" justifyContent="space-between" pt={2}>
              <Typography variant="h6">
                <FormattedMessage {...translations.total} />
              </Typography>
              <Typography variant="h6">
                {data?.total ? formatCurrency((data?.is_trial ? 0 : data.total) / 100) : '-'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default UpcomingInvoiceSection;
